module.exports = __webpack_public_path__ + "img/project10_1.jpg.97cca143.webp";